<template>
  <el-dialog
    title="编辑头像"
    :visible.sync="visible"
    append-to-body
    :close-on-click-modal="false"
    custom-class="edit-avatar-dialog"
    :before-close="handleClose"
    width="500px"
  >
    <el-form :model="form" ref="form" :rules="formRules" label-width="90px" label-position="left">
      <el-form-item label="头像:" prop="avatar">
        <div class="file-box" @click="handleAvatarClick">
          <img :src="form.avatarUrl" v-if="form.avatarUrl" class="file-img" />
          <i class="el-icon-plus u-font-36" v-else></i>
          <div class="remove-btn" v-if="form.avatarUrl" @click.stop="handleRemoveFile">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <input
          type="file"
          id="individualAvatar"
          accept="image/png, image/jpg, image/jpeg, image/webp, image/bmp"
          @change="handleAvatarChange"
          style="display: none;"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { putFileUrl, companyUploadAvatarUrl, individualUploadAvatarUrl } from '@/api'
export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      form: {},
      formRules: {
        avatar: { required: true, message: '请上传头像', trigger: 'blur' }
      },
      requesting: false // 图片上传，请求节流
    }
  },
  computed: {
    uploadUrl() {
      const uploadUrl = this.type === 'individual' ? individualUploadAvatarUrl : companyUploadAvatarUrl
      return uploadUrl
    }
  },
  methods: {
    open(form) {
      this.form = form
      this.visible = true
    },
    handleSave() {
      this.$refs.form.validate(async val => {
        if (val) {
          const loading = this.$loading({
            target: '.edit-avatar-dialog',
            text: '保存中，请稍候...'
          })
          try {
            let params = { ...this.form }
            delete params.avatarUrl
            await this.$post(this.uploadUrl, params, false)
            loading.close()
            this.visible = false
            this.$message.success('保存成功')
            this.$emit('loadAvatar')
          } catch {
            loading.close()
          }
        }
      })
    },
    // 点击头像上传
    handleAvatarClick() {
      if (this.requesting) {
        return
      }
      if (this.form.avatarUrl) {
        return
      }
      document.getElementById('individualAvatar').click()
    },
    // 上传头像
    async handleAvatarChange() {
      let dom = document.getElementById('individualAvatar')
      if (dom.files[0]) {
        if (!['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'].includes(dom.files[0].type)) {
          this.$message.warning('仅限上传 .png .jpg .jpeg .bmp 格式的图片')
          return
        }
        this.requesting = true
        const loading = this.$loading({
          target: '.edit-avatar-dialog .file-box'
        })
        try {
          let formData = new FormData()
          formData.append('file', dom.files[0])
          dom.value = '' // 清空已选文件
          let { data } = await this.$post(putFileUrl, formData)
          this.requesting = false
          loading.close()
          this.form.avatar = data.id
          this.form.avatarUrl = data.link
        } catch {
          this.requesting = false
          loading.close()
        }
      }
    },
    handleRemoveFile() {
      this.form.avatar = ''
      this.form.avatarUrl = ''
    },
    handleClose() {
      this.visible = false
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style lang="scss">
.edit-avatar-dialog {
  .file-box {
    width: 300px;
    height: 300px;
    border: 1px dashed #cecece;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border 0.2s, color 0.2s;
    cursor: pointer;
    position: relative;
    &:hover {
      border: 1px dashed $primary-color;
      color: $primary-color;
    }
  }
  .file-img {
    width: 100%;
    height: 100%;
  }
  .remove-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
  }
}
</style>
